import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { CommonService } from './../../services/common.service';
/**
 * Generated class for the PricingPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
 @Component({
 	
 	templateUrl: 'terms-policy.html'
 })
 export class CancellationRefundPage {

 	loggedInUser:any=null;
 	constructor(public navCtrl: NavController, public navParams: NavParams,public commonService:CommonService) {
 		this.loggedInUser=this.commonService.getLoggedInUserData();
 	}

 	ionViewDidLoad() {
 		console.log('ionViewDidLoad PricingPage');
 	}
 }



// WEBPACK FOOTER //
// ./src/pages/login/cancellation.ts